import React from "react";
import "./App.css";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Article from "./components/Article";
import Footer from "./components/Footer";

const App = () => (
  <div>
    <Nav />
    <Hero />
    <Article />
    <Footer />
  </div>
);

export default App;
